import { Router } from 'react-router-dom'
import { createHashHistory } from 'history'

export const history = createHashHistory()

export default class CustomRouter extends Router {
  history
}